import React from 'react'
import CommitRecord from '../oam/components/commit-record/CommoitRecord'

const  CollegeCommitRecord = () => {
  return (
    <div>
        <CommitRecord mode="college-oam"/>
    </div>
  )
}

export default CollegeCommitRecord